import React, { useRef } from "react";
import emailjs from "emailjs-com";
import "./ContactForm.css"
import Swal from "sweetalert2";
const ContactForm = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
    console.log(form.current, e.target);

    emailjs
      .sendForm(
        "service_x30ve8k",
        "template_6zg3ops",
        e.target,
        "user_UonJdqnxl9Ew8QGxnAXiq"
      )
      .then(
        (result) => {
          console.log(result.text);
          e.target.reset()
          Swal.fire("Your Message send successfully");
         
        },
        (error) => {
          console.log(error.text);
        }
      );
      
  };
  return (
    <div className="contact-form">
      <h2 className="conatct-me">Contact With Me</h2>
     <div>
     <form ref={form} onSubmit={sendEmail}>
        {/* <label>Name</label> */}
        <input required placeholder="Enter Your Name" type="text" name="user_name" />
        {/* <label>Email</label> */}
        <input required placeholder="Enter Your Email" type="email" name="user_email" />
        {/* <label>Message</label> */}
        <textarea required placeholder="Please Write message Here"  name="message" />
        <input id="contact-submitBtn" type="submit" value="Send" />
      </form>
     </div>
    </div>
  );
};

export default ContactForm;
